module.exports = __webpack_public_path__ + "img/feather.a31c2a8d.png";